import {
  createContext,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from "react";

import { Asset } from "../generated/gql/graphql";
import useAssets from "../hooks/query/asset/use-assets";

type AssetProviderContextType = {
  assets: Asset[];
};

export const AssetContext = createContext<AssetProviderContextType>({
  assets: [],
});

type Props = {
  children: ReactNode | ReactNode[];
};

export default function AssetProvider(props: Props): ReactElement {
  const { children } = props;

  const [assets, setAssets] = useState<Asset[]>([]);
  const { data } = useAssets();

  useEffect(() => {
    if (!data) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setAssets(data.assets.items);
  }, [data]);

  return (
    <AssetContext.Provider value={{ assets }}>{children}</AssetContext.Provider>
  );
}
